/**********************************************************************
 *
 * Copyright (C) 2022 Almendo Technologies GmbH
 * Copyright (C) 2022 Marcus Harringer
 *
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of
 * Marcus Harringer. The intellectual and technical concepts contained
 * herein are proprietary to Marcus Harringer and may be covered
 * copyright law. Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written permission
 * is obtained from Marcus Harringer.
 *
 ***********************************************************************/

import { getSsoLoginErrorKey } from '../../utils/ssoLogin';

const ERROR_KEYS = {
    NotAuthorizedException: 'auth.NLS_ERROR_NOT_AUTHORIZED',
    UserNotFoundException: 'auth.NLS_ERROR_USER_NOT_FOUND',
    UsernameExistsException: 'auth.NLS_ERROR_USER_EXISTS',
    InvalidPasswordException: 'auth.NLS_ERROR_INVALID_PASSWORD',
    CodeMismatchException: 'auth.NLS_ERROR_CODE_MISMATCH',
    ExpiredCodeException: 'auth.NLS_ERROR_CODE_EXPIRED',
    LimitExceededException: 'auth.NLS_ERROR_LIMIT_EXCEEDED',
    TooManyRequestsException: 'auth.NLS_ERROR_LIMIT_EXCEEDED'
};

//maps Cognito error codes to translated messages, falls back to the raw message
export const translateAuthError = (t, err) => {
    //rejections of the registration trigger (e.g. sign-up with a mail domain of an SSO customer)
    if (err?.name === 'UserLambdaValidationException') {
        return t(`sso.${getSsoLoginErrorKey(err.message)}`);
    }

    const key = ERROR_KEYS[err?.name];

    if (!key) {
        return err?.message;
    }

    //policy rejections carry the specific reason only in the raw message (e.g. leading/trailing space)
    if (err.name === 'InvalidPasswordException' && err.message) {
        return `${t(key)} (${err.message})`;
    }

    return t(key);
};

export default translateAuthError;
